<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div class="flex-between">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="活动筛选：" prop="activityConfigId">
              <el-select v-model="searchForm.activityConfigId" placeholder="请选择活动" class="mt-search-width">
                <el-option
                  v-for="item in activityConfigIdArr"
                  :key="item.id"
                  :label="item.activityName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户搜索：" prop="name">
              <el-input v-model="searchForm.name" placeholder="请输入昵称/手机号名称搜索" class="mt-search-width"></el-input>
            </el-form-item>
            <el-form-item label="结束时间：" prop="date">
              <el-date-picker
                v-model="searchForm.date"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="orderNo"
            label="记录编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="活动名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="获得奖品">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="抽奖时间">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryLotteryActivityLogPageList, queryAllLotteryActivityList } from '@/api/prizeDraw'
export default {
  name: 'PrizeDrawRecord',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      infoId: '',
      fullscreenLoading: false,
      searchForm: {
        name: '',
        activityConfigId: '',
        date: ['', '']
      },
      activityConfigIdArr: []
    }
  },
  mounted () {
    this.activityConfigIdFun();
    this.getInfoList()
  },
  methods: {
    // 获取所有的抽奖活动
    activityConfigIdFun(){
      var that = this;
      queryAllLotteryActivityList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.activityConfigIdArr = data
        }
        if (res.errorCode === '4002') {
          that.editForm.activityConfigId = '';
          that.activityConfigIdArr = []
        }
      })
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let activityConfigId = that.searchForm.activityConfigId
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let page = that.currentPage
      queryLotteryActivityLogPageList({ nickName: searchName,activityConfigId:activityConfigId,startCreateDate:startDate,endCreateDate:endDate,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/prizeDraw/Record.vue